import { apiClient } from "@base/api/client";
import type { UseSuspenseQueryOptions } from "@tanstack/react-query";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { ProjectWeather } from "./schema";

async function fetchProjectWeather(projectId: string): Promise<ProjectWeather> {
  const response = await apiClient.get<ProjectWeather>(`/project-management/api/projects/${projectId}/weather`);
  return response.data;
}

export function projectWeatherQueryOptions(projectId: string) {
  return {
    queryKey: ["project-weather", projectId] as const,
    queryFn: () => fetchProjectWeather(projectId),
  };
}

export function useProjectWeatherQuery(
  projectId: string,
  options?: Omit<UseSuspenseQueryOptions<ProjectWeather>, "queryKey" | "queryFn">,
) {
  return useSuspenseQuery({ ...projectWeatherQueryOptions(projectId), ...options });
}
